'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _widgetData = require('conversations-visitor-ui/reducers/widgetData');

var _widgetData2 = _interopRequireDefault(_widgetData);

var _prospectUtks = require('conversations-visitor-ui/reducers/prospectUtks');

var _prospectUtks2 = _interopRequireDefault(_prospectUtks);

var _requestStatus = require('conversations-core/reducers/requestStatus');

var _requestStatus2 = _interopRequireDefault(_requestStatus);

var _entities = require('conversations-core/reducers/entities');

var _entities2 = _interopRequireDefault(_entities);

var _currentChannel = require('conversations-core/reducers/currentChannel');

var _currentChannel2 = _interopRequireDefault(_currentChannel);

var _widgetUi = require('conversations-visitor-ui/reducers/widgetUi');

var _widgetUi2 = _interopRequireDefault(_widgetUi);

var _typing = require('conversations-core/reducers/typing');

var _typing2 = _interopRequireDefault(_typing);

var _clientData = require('conversations-core/reducers/clientData');

var _clientData2 = _interopRequireDefault(_clientData);

var _pubNubStatus = require('conversations-core/reducers/pubNubStatus');

var _pubNubStatus2 = _interopRequireDefault(_pubNubStatus);

var _benderContext = require('conversations-core/reducers/benderContext');

var _benderContext2 = _interopRequireDefault(_benderContext);

var _outgoingMessages = require('conversations-core/reducers/outgoingMessages');

var _outgoingMessages2 = _interopRequireDefault(_outgoingMessages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  requestStatus: _requestStatus2.default,
  prospectUtks: _prospectUtks2.default,
  widgetData: _widgetData2.default,
  entities: _entities2.default,
  currentChannel: _currentChannel2.default,
  widgetUi: _widgetUi2.default,
  typing: _typing2.default,
  clientData: _clientData2.default,
  pubNubStatus: _pubNubStatus2.default,
  benderContext: _benderContext2.default,
  outgoingMessages: _outgoingMessages2.default
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/index.js
// module id = 556
// module chunks = 0